<mat-sidenav-container class="sidenav-container">
    <div class="loading-indicator" [hidden]="!isLoadingResults">
        <mat-spinner class="spinner" [diameter]="150" mode="indeterminate"></mat-spinner>
    </div>
    <router-outlet></router-outlet>

</mat-sidenav-container>